/* テキストコントロール */
import React, { memo } from 'react';
import Messages from '../Messages';
var InputText = function (_a) {
    var id = _a.id, title = _a.title, class_name = _a.class_name, name = _a.name, value = _a.value, handleChange = _a.handleChange, help_message = _a.help_message, valid_message = _a.valid_message, disabled = _a.disabled, onBlur = _a.onBlur;
    return (React.createElement(React.Fragment, null, disabled ? (React.createElement(React.Fragment, null,
        React.createElement("span", { className: "detail-criteria-head" }, title),
        React.createElement("div", { className: "detail-form-input" },
            value,
            React.createElement(Messages, { help_msg: help_message, valid_msg: valid_message })))) : (React.createElement(React.Fragment, null,
        React.createElement("span", { className: "detail-criteria-head" }, title),
        React.createElement("div", { className: "detail-form-input" },
            React.createElement("input", { id: id, type: "text", className: class_name, name: name, value: value, onChange: handleChange, disabled: disabled, onBlur: onBlur }),
            React.createElement(Messages, { help_msg: help_message, valid_msg: valid_message }))))));
};
export default memo(InputText);
